import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { change, FieldArray, FormSection, reduxForm } from 'redux-form';
import CustomerPostalAddress from 'components/Customer/CustomerPostalAddress';
import { connect } from 'react-redux';
import CustomerAccountPanel from 'components/Customer/CustomerAccountPanel';
import CustomerJotrsPanel from 'components/Customer/CustomerJotrsPanel';
import CustomerDetailsPanel from 'components/Customer/CustomerDetailsPanel';

const CustomerEditForm = ({
  handleSubmit,
  initialValues,
  jurisdictions,
  isEditingCustomer,
  dispatch,
  onAccountDropdownChange,
  dataSource
}) => {
  jurisdictions ??= [];

  const [accountIndex, setAccountIndex] = useState(0);

  useEffect(() => {
    // Executes on mount - load first account
    const selectedAccount = initialValues?.accounts && initialValues.accounts.length > 0 && initialValues.accounts[0].account;
    onAccountDropdownChange(selectedAccount);
    dispatch(change('customerEditForm', 'selectedAccountId', selectedAccount?.id));
  }, []);

  const handleAccountChange = (lookupValue) => {
    const selectedAccount = initialValues.accounts[lookupValue].account;
    onAccountDropdownChange(selectedAccount);
    setAccountIndex(lookupValue);
    dispatch(change('customerEditForm', 'selectedAccountId', selectedAccount?.id));
  };

  return (
    <form
      className="customer-edit-form"
      onSubmit={ handleSubmit }
    >
      <div className="customer-account-grid">
        <FormSection
          name="customer"
          component={ CustomerDetailsPanel }
          isEditingCustomer={ isEditingCustomer }
          jurisdictions={ jurisdictions }
          dispatch={ dispatch }
          customerNameValue={ initialValues.customer.name }
          customerNamePartsValue={ initialValues.customer.nameParts }
        />
        <FormSection
          name={ `accounts[${ accountIndex }]` }
          component={ CustomerAccountPanel }
          accounts={ initialValues?.accounts }
          isEditingCustomer={ isEditingCustomer }
          jurisdictions={ jurisdictions }
          onAccountChange={ handleAccountChange }
        />
      </div>
      <FieldArray
        name="customerAddresses"
        component={ CustomerPostalAddress }
        isEditingCustomer={ isEditingCustomer }
        jurisdictions={ jurisdictions }
        dispatch={ dispatch }
        dataSource={ dataSource }
      />
      <FieldArray
        name="taxResidencies"
        component={ CustomerJotrsPanel }
        isEditingCustomer={ isEditingCustomer }
        jurisdictions={ jurisdictions }
        dispatch={ dispatch }
        dataSource={ dataSource }
      />
    </form>
  );
};

CustomerEditForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.shape(),
  jurisdictions: PropTypes.arrayOf(PropTypes.shape()),
  isEditingCustomer: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  onAccountDropdownChange: PropTypes.func,
  dataSource: PropTypes.string.isRequired
};

CustomerEditForm.defaultProps = {
  handleSubmit: null,
  initialValues: null,
  jurisdictions: null,
  isEditingCustomer: false,
  onAccountDropdownChange: null,
};

const mapDispatchToProps = dispatch => ({ dispatch });

const CustomerEditReduxForm = reduxForm({
  form: 'customerEditForm',
  enableReinitialize: true
})(CustomerEditForm);

export default connect(
  mapDispatchToProps,
)(CustomerEditReduxForm);
